import styled from "styled-components";

export const BillboardSectionFormContainer = styled.div`
  height: 100%;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;

  .billboard-section-form-title {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    flex-direction: column;
    gap: 1rem;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    .title {
      display: flex;

      h1 {
        align-items: center;
        color: ${({ theme }) => theme.groups.primaryText};
        display: flex;
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: max(1.2vw, 1.5rem);
        line-height: 150%;
        margin: 0;

        :first-child {
          opacity: 0.6;

          :hover {
            cursor: pointer;
          }
        }

        svg * {
          stroke: ${({ theme }) => theme.groups.secondaryText} !important;
        }
      }
    }

    .btn-billboard-section-form {
      display: flex;
      gap: 0.5rem;

      button {
        align-items: center;
        background: ${({ theme }) =>
          theme.controlPanel.billboardBackgroundListItems};
        border-radius: 0.25rem;
        border: none;
        color: ${({ theme }) => theme.groups.secondaryText};
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: max(0.6vw, 0.875rem);
        justify-content: center;
        padding: 0.5rem 1rem;
        line-height: 150%;
        opacity: 0.8;
        transition: all 100ms ease-in-out;

        :hover {
          cursor: pointer;
          opacity: 1;
        }

        svg {
          height: 1rem;
          width: 1rem;
          stroke: #f2f2f2 !important;
        }
      }

      #submit {
        background: #236c33;
        color: #f2f2f2;
      }
    }
  }

  .form-content {
    align-items: flex-start;
    background: ${({ theme }) =>
      theme.controlPanel.billboardBackgroundListItems};

    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    gap: 1rem;

    @media screen and (min-width: 1024px) {
      gap: 1.5rem;
    }

    .create-billboard-input {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      margin-bottom: 0.5rem;
      width: 100%;

      @media screen and (min-width: 1024px) {
        flex-direction: row;
        margin-bottom: 1.5rem;

        div {
          width: 50%;
        }

        input {
          width: 50%;
        }
      }

      div {
        width: 100%;
      }

      div h6 {
        color: ${({ theme }) => theme.groups.primaryText};
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: 1rem;
        line-height: 150%;
        margin: 0;
      }

      div span {
        color: ${({ theme }) => theme.groups.secondaryText};
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 150%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      input {
        align-items: center;
        background: ${({ theme }) =>
          theme.controlPanel.billboardBackgroundButtonConfig};
        border: none;
        border-radius: 0.5rem;
        color: ${({ theme }) => theme.groups.secondaryText};
        display: flex;
        flex-direction: row;
        gap: 0.625rem;
        padding: 0.75rem 1rem;
        width: 100%;
      }

      select {
        background: ${({ theme }) =>
          theme.controlPanel.billboardBackgroundButtonConfig};
        border-radius: 0.5rem;
        border: none;
        color: ${({ theme }) => theme.groups.secondaryText};
        padding: 0.75rem 1rem;
        width: 100%;

        :hover {
          cursor: pointer;
        }

        ::after {
          content: "";
          background-color: red;
        }
      }
    }

    .create-billboard-switch {
      display: flex;
      gap: 0.5rem;
      margin-bottom: 1.5rem;
      width: 100%;

      .text-content {
        width: 50%;

        p {
          font-style: normal;
          font-weight: 600;
          font-size: 1rem;
          line-height: 150%;
        }

        span {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .switch-container {
        width: max-content;

        @media screen and (min-width: 1024px) {
          width: 52%;
        }
      }
    }

    .billboard-tags {
      align-items: center;
      display: flex;
      justify-content: start;

      width: 100%;

      .text-content {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 2rem;
        width: 100%;

        @media screen and (min-width: 1024px) {
          width: 49.5%;
        }

        p {
          color: ${({ theme }) => theme.groups.primaryText};
          font-family: "Inter";
          font-style: normal;
          font-weight: 600;
          font-size: 1rem;
          line-height: 150%;
          margin: 0;
        }

        span {
          color: ${({ theme }) => theme.groups.secondaryText};
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-size: 0.875rem;
          line-height: 150%;
          margin: 0;
        }
      }

      button {
        background: ${({ theme }) => theme.colors.primary};
        border-radius: 0.25rem;
        border: none;
        color: ${({ theme }) => theme.colors.textMasterColor};
        display: flex;
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: max(0.6vw, 0.875rem);
        justify-content: center;
        align-items: center;
        padding: 0.5rem 1rem;
        gap: 0.5rem;
        line-height: 150%;
        max-height: 37px;
        opacity: 0.8;
        transition: all 100ms ease-in-out;

        :hover {
          cursor: pointer;
          opacity: 1;
        }
      }
    }

    .selected-tags-container {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      width: 100%;

      @media screen and (min-width: 600px) {
        flex-wrap: wrap;
        flex-direction: row;
      }

      p {
        background: ${({ theme }) =>
          theme.controlPanel.billboardBackgroundButtonConfig};
        border-radius: 0.25rem;
        border: none;
        color: ${({ theme }) => theme.groups.secondaryText};
        display: flex;
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: max(0.6vw, 0.875rem);
        gap: 0.25rem;
        justify-content: space-between;
        padding: 0.5rem 1rem;
        line-height: 150%;
        max-height: 37px;
        opacity: 0.8;
        margin: 0;
        width: 100%;

        @media screen and (min-width: 600px) {
          width: max-content;
        }

        svg {
          width: 20px;
          height: 20px;

          :hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .remove-session {
    background: ${({ theme }) =>
      theme.controlPanel.billboardBackgroundListItems};
    display: flex;
    justify-content: space-between;
    padding-top: 1.5rem;
    border-top: 1px solid
      ${({ theme }) => theme.controlPanel.billboardBackgroundButtonConfig};
    width: 100%;

    .text-content {
      width: 50%;
    }

    p {
      align-items: center;
      color: #ed1515;
      display: flex;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: 1rem;
      line-height: 150%;
      margin: 0;
    }

    span {
      color: ${({ theme }) => theme.groups.primaryText};
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 150%;
      margin: 0;
    }

    button {
      color: #f2f2f2;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border: none;
      padding: 0.5rem 1rem;
      gap: 0.5rem;
      background: #af0000;
      border-radius: 0.25rem;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 150%;
      height: 46px;

      :hover {
        cursor: pointer;
      }
    }
  }
`;
